import Button from '../atoms/Button';
import ItemCard from '../cards/ItemCard';
import css from './ItemsGrid.module.scss';

export default function ItemsGrid({ items, handleMore, displayShowMore, loadingMore }) {
  return (
    <>
      <div className={css['grid']}>
        {items.map((item) => {
          return <ItemCard {...item} key={item.id} />;
        })}
      </div>
      <div className={css['button']}>
        {displayShowMore && (
          <Button label={loadingMore ? 'Loading...' : 'Show More'} action={handleMore} />
        )}
      </div>
    </>
  );
}
